module.exports = __webpack_public_path__ + "img/chrome.e6bb8299.png";